import Canvas from "./components/canvas.jsx";

function App() {
  return <Canvas />;
}

export default App;
